import { AppState } from 'store/root.reducer'

export const selectDictionaryState = (state: AppState) => state?.dictionary

export const selectDictionary = (state: AppState) => selectDictionaryState(state)?.dictionary
